







































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '@/components/PublicQuery/PublicQuery'
import Echarts from '@/components/Echarts/Echarts.vue'
import { UserModule } from '../../store/modules/user'
import { DateUnitTypeMap, EDateUnitType, DevTypeMap, StatsEnergyTabsMap, EStatsEnergyUnit, StatsLocalUnitMap, EStatsLocalUnit, EDevType, SingleTypeMap } from '../../model/const'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import SelectDepartment from '@/components/Select/SelectDepartment.vue'
import api from '../../api'
import config from '@/config'
import { formatDate, accMul } from '../../utils/utils'
import { UnitControlTypeMap } from '@/model/const'
import { log } from 'console'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import md5 from 'js-md5'

@Component({
  components: {
    PublicQuery,
    Echarts,
    SelectRegion,
    SelectDepartment,
  },
})
export default class StatsElectricEchart extends Vue {
  private noData1: boolean = false
  private option1: any = {}
  private echartsOption: any = {}
  private isCompareStatus: boolean = false
  private isNotData: boolean = false
   private Datalist: any = ''
   private listdata: any = ''
  private statsEnergyUnit: EStatsEnergyUnit = EStatsEnergyUnit.ADDTIME
  private statsEnergyTabs: any[] = Array.from(StatsEnergyTabsMap).map(([name, label]) => ({ label, name }))
  private typeOption: any[] = Array.from(StatsLocalUnitMap).map(([value, label]) => ({ label, value }))
  private devTypeOption: any[] = Array.from(DevTypeMap).map(([value, label]) => ({ label, value }))
  private lineColors: any[] = ['#d4ac60', '#3b65ff', '#ff742a']
  private lineComparseColors: any[] = ['#ffa500', '#2CBE60', '#cd5c5c']
  private queryItems: IFormItem[] = [
    {
      label: '统计时长',
      key: 'unit',
      type: 'select',
      options: [...DateUnitTypeMap].map(([value, label]) => ({
        label,
        value,
      })),
    },
    {
      label: '统计类型',
      key: 'singleType',
      type: 'select',
      options: [...SingleTypeMap].map(([value, label]) => ({
        label,
        value,
      })),
    },
    {
      label: '选择日期',
      key: 'date',
      type: 'date',
      dateType: 'daterange',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
 protected queryParams = {
   date: [],
   unit: 'DAY',
   region: [],
   type: 1,
   singleType: 'single',
   cdate: [],
   devType: EDevType.AIR,
 }
  @Watch('queryParams.unit')
 private watchUnit(now: EDateUnitType) {
   let dateType = ''
   switch (now) {
     case EDateUnitType.DAY:
       dateType = 'daterange'
       break
     case EDateUnitType.MONTH:
       dateType = 'monthrange'
       break
     case EDateUnitType.YEAR:
       dateType = 'monthrange'
       break
     default:
       dateType = 'daterange'
       break
   }
   if (this.queryItems.findIndex(_ => _.key === 'date') !== -1) {
     this.queryItems.splice(this.queryItems.findIndex(_ => _.key === 'date'), 1, {
       label: '选择日期',
       key: 'date',
       type: 'date',
       dateType: dateType as any,
       pickerOptions: {
         disabledDate(time) {
           return time.getTime() > Date.now()
         },
       },
     })
   }
   if (this.queryItems.findIndex(_ => _.key === 'cdate') !== -1) {
     this.queryItems.splice(this.queryItems.findIndex(_ => _.key === 'cdate'), 1, {
       label: '对比日期',
       key: 'cdate',
       type: 'date',
       dateType: dateType as any,
       pickerOptions: {
         disabledDate(time) {
           return time.getTime() > Date.now()
         },
       },
     })
   }
 }
  // 创建一个worksheet,创建过程中设置表头
  private createWs(data, fields, titles) {
    const ws = XLSX.utils.json_to_sheet(
      data,
      {
        header: fields,
      }
    )
    const range = XLSX.utils.decode_range(ws['!ref'])

    for (let c = range.s.c; c <= range.e.c; c++) {
      const header = XLSX.utils.encode_col(c) + '1'
      ws[header].v = titles[ ws[header].v ]
    }

    return ws
  }
  private exportExcel() {
      const timeStamp = Date.now()
    // let data={
    //      orgId: UserModule.orgInfo.orgId,
    //       devs: devs,
    //       unit,
    //       single: singleType,
    //       start: date[0],
    //       end: date[1],
    //       type,
    // }

  let that = this
    const orgId = UserModule.orgInfo.orgId
    

     
    api.getElectricInfo({ orgId }).then((res) => {
      let arr = []
      console.log(res)

      for (let i in res) {
        let obj = {
          label: '',
          value: '',

        }
        obj.label = i
        obj.value = i
        arr.push(obj)
      }
      console.log(arr)
      that.listdata = arr
      // that.queryItems[0].options=arr

      const orgId = UserModule.orgInfo.orgId
      const { region = [], unit = '', date = [], cdate = [], type = 1, singleType = '' } = this.queryParams || {}
      var str = region.join()
      var split = str.split(',')
      // var devs = ['98CC4D40142F','98CC4D40142F']

      var devs = []
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index].value
        if (element.length === 12) {
          devs.push(element)
        }
      }
      if (devs.length === 0) {
        this.$message.warning('项目无智慧空开')
      } else {
        if (!date || !date.length) {
          this.$message.warning('请选择日期')
          return
        }
        // if (!region || !region.length) {
        //   if (type === EStatsLocalUnit.POSITION) {
        //     this.$message.warning('请选择统计位置')
        //   }
        //   if (type === EStatsLocalUnit.DEPARTMENT) {
        //     this.$message.warning('请选择统计部门')
        //   }
        //   return
        // }
        if (this.isCompareStatus && (!cdate || !cdate.length)) {
          this.$message.warning('请选择对比日期')
          return
        }
          this.$message.info('正在导出数据，请稍后')
          fetch(config.apiBaseUrl+"/V1/Electric/export", {
  method: 'POST',
    responseType: 'blob',
    // contentType: 'application/json;charset=UTF-8',
 
 

  headers: {
      'Content-Type': 'application/json', // 设置内容类型为 JSON
    

   

     'Name': UserModule.name,
        'Token': UserModule.token,
        'Time-Stamp': timeStamp,
        'platform': 'manageWeb',
        'Sign': md5(`${UserModule.name}${UserModule.token}${timeStamp}${UserModule.staticKey}`),
  },
  
  body: JSON.stringify({
           orgId: UserModule.orgInfo.orgId,
            devs: devs,
          unit,
          single: singleType,
          start: date[0],
          end: date[1],
          type,
          })
})
.then(response =>response.blob()
)
.then(data => {
  that.$message.success('导出成功')
  console.log(data);
  
  let downloadFilename = 'out.xlsx'//设置导出的文件名
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //兼容ie浏览器  
    window.navigator.msSaveOrOpenBlob(data, downloadFilename)
  } else {
    //谷歌,火狐等浏览器
    let url = window.URL.createObjectURL(data)
    let downloadElement = document.createElement("a")
    downloadElement.style.display = "none"
    downloadElement.href = url
    downloadElement.charset = 'UTF-8'
    downloadElement.download = downloadFilename
    document.body.appendChild(downloadElement)
    downloadElement.click()
    document.body.removeChild(downloadElement)
    window.URL.revokeObjectURL(url)
  }
})
.catch(error => console.error('Error:', error));

 
        // api.exportElectric({
        //    orgId: UserModule.orgInfo.orgId,
        //   devs: devs,
        //   unit,
        //   single: singleType,
        //   start: date[0],
        //   end: date[1],
        //   type,

        // }).then((res) => {
        //   // console.log(13);
        //   // console.log(res);
        //   // FileSaver.saveAs(res.data, '导出.xlsx')
          
          
        //   // console.log(JSON.stringify(res) )
        //     const blob = new Blob([res.data], { type: "application/vnd.ms-excel" })
        //     // console.log(blob);
            
        // // const blob = new Blob([response.data]);
        // // const blob = response.data;

        // let downloadFilename = '导出.xlsx'//设置导出的文件名
        // let url = window.URL.createObjectURL(blob)
        //     let downloadElement = document.createElement("a")
        //     downloadElement.style.display = "none"
        //     downloadElement.href = url
        //     downloadElement.charset = 'UTF-8'
        //     downloadElement.download = downloadFilename
        //     document.body.appendChild(downloadElement)
        //     downloadElement.click()
        //     document.body.removeChild(downloadElement)
        //     window.URL.revokeObjectURL(url)
          
        // })
      }
  })
  return

 



    /* 从表生成工作簿对象 */
    console.log(this.noData1)
    if (this.Datalist === '') {
      this.$message.warning('请先生成出图表')
    } else {
    // 创建工作簿
      const workbook = XLSX.utils.book_new()
      console.log(this.Datalist)
      console.log(this.listdata)
      let datza = []
      const titles = {
        devId: '空开设备id',
        addTime: '当日新增电量',
        ope: '当日累计电量',
        countDate: '日期',

      }
      const fields = ['devId', 'addTime', 'ope', 'countDate']

      //  for (let z = 0; z < this.listdata.length; z++) {
      //   datza=this.listdata[z].label

      for (let i = 0; i < this.listdata.length; i++) {
        console.log(this.Datalist[this.listdata[i].label])
        // 创建工作表
        // const worksheet = XLSX.utils.json_to_sheet( this.Datalist[this.listdata[i].label])
        const worksheet = this.createWs(this.Datalist[this.listdata[i].label], fields, titles)

        // 将工作表添加到工作簿
        XLSX.utils.book_append_sheet(workbook, worksheet, this.listdata[i].label)
      }
      //  }

      // 将工作簿保存为Excel文件
      XLSX.writeFile(workbook, 'output.xlsx')
    }
  }

  private handleTabClick() {
    this.queryChange()
  }

  private onCompareBtn() {
    this.isCompareStatus = !this.isCompareStatus
  }
  @Watch('isCompareStatus')
  private watchIsCompareStatus(now: boolean) {
    const cdateIndex = this.queryItems.findIndex(item => item.key === 'cdate')
    const devTypeIndex = this.queryItems.findIndex(item => item.key === 'devType')
    if (now) {
      if (cdateIndex === -1) {
        this.queryItems.push({
          label: '对比日期',
          key: 'cdate',
          type: 'date',
          dateType: 'daterange',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() > Date.now()
            },
          },
        })
      }
      // if (devTypeIndex === -1) {
      //   this.queryItems.push({
      //     label: '对比设备',
      //     key: 'devType',
      //     type: 'select',
      //     options: this.devTypeOption,
      //   })
      //   this.queryParams.devType = this.devTypeOption[0] ? this.devTypeOption[0].value : ''
      // }
      this.watchUnit(this.queryParams.unit as any)
    } else {
      if (devTypeIndex !== -1) this.queryItems.splice(devTypeIndex, 1)
      if (cdateIndex !== -1) this.queryItems.splice(cdateIndex, 1)
      this.queryChange()
    }
  }
  private getEledev() {
    let that = this
    const orgId = UserModule.orgInfo.orgId
    api.getElectricInfo({ orgId }).then((res) => {
      let arr = []
      console.log(res)
      // that.Datalist=res
      let obj = {
        label: '',
        value: '',

      }

      for (let i in res) {
        obj.label = i
        obj.value = i
        arr.push(obj)
      }
      console.log(arr)
      that.listdata = arr
      // that.queryItems[0].options=arr
    })
  }
  private queryChange() {
    // this.getEledev()
    let that = this
    const orgId = UserModule.orgInfo.orgId
    api.getElectricInfo({ orgId }).then((res) => {
      let arr = []
      console.log(res)

      for (let i in res) {
        let obj = {
          label: '',
          value: '',

        }
        obj.label = i
        obj.value = i
        arr.push(obj)
      }
      console.log(arr)
      that.listdata = arr
      // that.queryItems[0].options=arr

      const orgId = UserModule.orgInfo.orgId
      const { region = [], unit = '', date = [], cdate = [], type = 1, singleType = '' } = this.queryParams || {}
      var str = region.join()
      var split = str.split(',')
      // var devs = ['98CC4D40142F','98CC4D40142F']

      var devs = []
      for (let index = 0; index < arr.length; index++) {
        const element = arr[index].value
        if (element.length === 12) {
          devs.push(element)
        }
      }
      if (devs.length === 0) {
        this.$message.warning('项目无智慧空开')
      } else {
        if (!date || !date.length) {
          this.$message.warning('请选择日期')
          return
        }
        // if (!region || !region.length) {
        //   if (type === EStatsLocalUnit.POSITION) {
        //     this.$message.warning('请选择统计位置')
        //   }
        //   if (type === EStatsLocalUnit.DEPARTMENT) {
        //     this.$message.warning('请选择统计部门')
        //   }
        //   return
        // }
        if (this.isCompareStatus && (!cdate || !cdate.length)) {
          this.$message.warning('请选择对比日期')
          return
        }
        let statsrequst = api.getElectricEnergyBehavior1({
          orgId: UserModule.orgInfo.orgId,
          devs: devs,
          unit,
          single: singleType,
          start: date[0],
          end: date[1],
          type,
        })
        // console.log(statsrequst);
        // console.log(this.isCompareStatus);

        if (this.isCompareStatus) {
          Promise.all([statsrequst, api.getElectricEnergyBehavior1({
            orgId: UserModule.orgInfo.orgId,
            devs: devs,
            unit,
            single: singleType,
            start: cdate[0],
            end: cdate[1],
            type,
          })]).then(([data, compareData]) => {
            data = Object.entries(data).map(([key, value]: any[]) => {
              return {
                devName: key,
                value: value,
              }
            })
            compareData = Object.entries(compareData).map(([key, value]: any[]) => {
              return {
                devName: key,
                value: value,
              }
            })
            this.getEcahrtsSumRunTimeCompare(data, compareData)
            console.log(data, compareData)

            this.isNotData = false
          })
        } else {
          statsrequst.then((data) => {
            console.log(data)
            that.Datalist = data
            var start = date[0]
            var end = date[1]
            var startTime = this.getDate(start)

            console.log(startTime.getDate())

            var endTime = this.getDate(end)
            // startTime=new Date(startTime)
            // endTime=new Date(endTime)
            //    console.log(startTime);
            var times = []
            while ((endTime.getTime() - startTime.getTime()) >= 0) {
              var year = startTime.getFullYear()
              var month = (startTime.getMonth() + 1).toString().length === 1 ? '0' + (startTime.getMonth() + 1).toString() : startTime.getMonth() + 1
              var day = startTime.getDate().toString().length === 1 ? '0' + startTime.getDate() : startTime.getDate()
              console.log(year + '-' + month + '-' + day)
              startTime.setDate(startTime.getDate() + 1)
              times.push(year + '-' + month + '-' + day)
            }
            var list1:any = []
            times.forEach(element1 => {
              let allope:number = 0.00
              let alladdTime:number = 0.00
              for (var key in data) {
                // console.log('data' + key + JSON.stringify(data[key]))
                var list: [] = data[key]
                for (let index = 0; index < list.length; index++) {
                  const element = list[index]
                  if (element['countDate'] === element1) {
                    // console.log('===' + element['ope'])
                    // console.log('---' + parseFloat(element['ope']).toFixed(2))
                    var ope = parseFloat(element['ope'])
                    var addTime = parseFloat(element['addTime'])
                    allope = allope + ope
                    alladdTime = alladdTime + addTime
                  }
                }
              }
              var logs = { 'devId': '000000000000', 'addTime': alladdTime, 'ope': allope, 'countDate': element1, 'devName': '全部' }
              list1.push(logs)
            })
            // console.log('///////////////data' + JSON.stringify(data))
            // console.log('///////////////list' + JSON.stringify(list1))
            const tabList = {
              全部: list1,
            }
            if (singleType === 'single') {
              this.getEchartsSumRunTime(data)
            } else {
              this.getEchartsSumRunTime(tabList)
            }
            // console.log(JSON.stringify(tabList))
            this.isNotData = false
          })
        }
      }
    })
  }

  private getDate(datestr:any) {
    var temp = datestr.split('-')
    console.log(temp)

    // var date = new Date(temp[0], temp[1], temp[2])
    var date = new Date(datestr)

    return date
  }

  private getElectricPowerLogData(logs: any[], baseVal: number, minTime: any, maxTime: any) {
    let logResult:any = []
    for (let index:any = 0; index < logs.length; index++) {
      if ((logs[index].ope) !== 0) {
        logResult.push([logs[index].time, Number(logs[index].ope), logs[index]])
      }
    }
    return logResult
  }

  private costumDateFormatter(value: any) {
    let result = ''
    switch (this.queryParams.unit) {
      case EDateUnitType.DAY:
        result = formatDate(value, 'MM月DD日')
        break
      case EDateUnitType.MONTH:
        result = formatDate(value, 'YYYY年MM月')
        break
      case EDateUnitType.YEAR:
        result = formatDate(value, 'YYYY年')
        break
      default:
        result = ''
        break
    }
    return result
  }
  private axisLabelDateFormatter(value: any) {
    let result = ''
    switch (this.queryParams.unit) {
      case EDateUnitType.DAY:
        result = formatDate(value, 'MM-DD')
        break
      case EDateUnitType.MONTH:
        result = formatDate(value, 'YY-MM')
        break
      case EDateUnitType.YEAR:
        result = formatDate(value, 'YYYY')
        break
      default:
        result = ''
        break
    }
    return result
  }
  private axisLabelUnitFormatter(value: number) {
    return value > 1000 ? `${value / 1000}k` : value
  }
  /** 汇总图 */
  private getEchartsSumRunTime(data: any) {
    data = Object.entries(data).map(([key, value]: any[]) => {
      return {
        devName: key,
        value: value,
      }
    })
    console.log(data);
    
    this.echartsOption = {
      title: {
        text: `电表电量${StatsEnergyTabsMap.get(this.statsEnergyUnit)}变化趋势`,
      },
      color: this.lineColors,
      graphic: [
        {
          type: 'text',
          z: 100,
          left: 'center',
          bottom: 0,
          cursor: 'default',
          style: {
            fill: '#666666',
            text: `${StatsEnergyTabsMap.get(this.statsEnergyUnit)} ${this.axisLabelDateFormatter(this.queryParams.date[0])}至${this.axisLabelDateFormatter(this.queryParams.date[1])}`,
            font: '14px Microsoft YaHei',
          },
        },
      ],
      toolbox: {
        right: '3%',
        top: 40,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {
            name: '电量分析',
          },
        },
      },
      legend: {
        data: data.map((item) => item.devName).reverse(),

        itemHeight: 10, // 改变圆圈大小
        icon: 'circle',
        right: '3%',
        textStyle: {
          fontSize: 14,
        },
        tooltip: {
            show: true,
            formatter: function (params) {
              // console.log(params);
              // console.log(data);
              for(let i=0;i<data.length;i++){
                if(params.name==data[i].devName){
                  return params.name + '<br/>' +  data[i].value[0].netName.join('</br>')
                  }
              }
              
              
                // 这里可以自定义弹窗内容
                // return params.name + ': ' + params.value;
            }
        }
      },
      grid: {
        left: '3%',
        right: '3%',
        top: 90,
        bottom: '5%',
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any[]) => {
          let result = ''
          result += params.reduce((prev, curr, index) => {
            // console.log(curr)
            let all=0;
            for(let i=0;i<params.length;i++){
               all+=params[i].value[1];

            }
             
            // console.log(data);
            
            if (index === 0) {
              prev += `${formatDate(curr.axisValue, 'YYYY-MM-DD')}<br>`
              prev += `当前总量 ${all.toFixed(2)}kWh<br>`

            }
            // let name12=curr.value[2].netName.join('</br>')

            // const rsc = prev += `${curr.marker}${StatsEnergyTabsMap.get(this.statsEnergyUnit)}&nbsp&nbsp${curr.value[2][this.statsEnergyUnit]}<br/>`

            const rsc = prev += `${curr.marker}${StatsEnergyTabsMap.get(this.statsEnergyUnit)}--${curr.value[2].devId}&nbsp&nbsp${curr.value[2][this.statsEnergyUnit]}<br/>`
            return rsc
          }, result)
          return result
        },
      },
      xAxis: {
        type: 'category',
        minInterval: 1,
        axisLabel: {
          formatter: this.axisLabelDateFormatter,
          rotate: 60,
        },
        axisTick: {
          show: false,
          alignWithLabel: true,
        },
        axisLine: {
          show: false,
        },
      },
      yAxis: {
        name: '电量(kWh)',
        type: 'value',
        nameLocation: 'end',
        nameTextStyle: {
          align: 'right',
          padding: [0, 0, 9, 0],
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          formatter: this.axisLabelUnitFormatter,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      series: data.map((goods: any) => {
        return {
          name: goods.devName,
          data: goods.value.map((item: any) => ([
            item.countDate,
            item[this.statsEnergyUnit],
            item,
          ])),
          // showSymbol: false,
          tooltip: {
            trigger: 'axis',
          },
          type: 'bar',
           stack: 'Ad',
          smooth: true,
        }
      }).reverse(),
    }
  }
  /** 对比图 */
  private getEcahrtsSumRunTimeCompare(data: any[], cdata: any[]) {
    // console.log('data' + JSON.stringify(data))
    // console.log('cdata' + JSON.stringify(cdata))
    this.echartsOption = {
      title: {
        text: `设备运行${StatsEnergyTabsMap.get(this.statsEnergyUnit)}变化趋势(对比)`,
      },
      // color: this.lineColors,
      toolbox: {
        right: '3%',
        top: 40,
        feature: {
          dataZoom: {
            yAxisIndex: 'none',
          },
          restore: {},
          saveAsImage: {
            name: '电量统计(对比)',
          },
        },
      },
      legend: {
        // data: devs.map((item) => item.devName).reverse(),
        itemHeight: 14, // 改变圆圈大小
        icon: 'circle',
        left: 'center',
        bottom: 0,
        itemGap: 80,
        textStyle: {
          fontSize: 14,
        },
      },
      grid: {
        left: '3%',
        right: '3%',
        top: 90,
        bottom: '5%',
        containLabel: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any[]) => {
          let result = ''
          result += params.reduce((prev, curr, index) => {
            const item = curr.data.item.devName
            prev += `${curr.data.item.timeTitle}: ${formatDate(curr.data.item.countDate, 'YYYY-MM-DD')}<br>`
            const rsc = prev += `${curr.marker}${StatsEnergyTabsMap.get(this.statsEnergyUnit)}-${curr.data.item.devId}&nbsp&nbsp${curr.data.item[this.statsEnergyUnit]}<br/>`
            return rsc
          }, result)
          return result
        },
      },
      xAxis: {
        type: 'category',
        data: data[0] && Array.isArray(data[0].value) ? data[0].value.map((item: any) => item.countDate) : [],
        axisLabel: {
          interval: 0,
          formatter: this.axisLabelDateFormatter,
          rotate: 60,
        },
        axisTick: {
          show: false,
          alignWithLabel: true,
        },
        axisLine: {
          show: false,
        },
      },
      yAxis: {
        name: '电量(kWh)',
        type: 'value',
        nameLocation: 'end',
        nameTextStyle: {
          align: 'right',
          padding: [0, 0, 9, 0],
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          formatter: this.axisLabelUnitFormatter,
        },
        splitLine: {
          lineStyle: {
            type: 'dashed',
          },
        },
      },
      series: [
        ...data.filter(item => item.devName).map((goods: any, index: number) => {
          // console.log('goods' + goods)
          return {
            name: `${this.axisLabelDateFormatter(this.queryParams.date[0])}至${this.axisLabelDateFormatter(this.queryParams.date[1])}${StatsEnergyTabsMap.get(this.statsEnergyUnit)} -${goods.devName}`,
            tooltip: {
              trigger: 'axis',
            },
            type: 'line',
            smooth: true,
            // symbol: 'circle',
            // symbolSize: 8,
            showSymbol: false,
            itemStyle: {
              normal: {
                color: this.getLineColor(goods.devName).color,
              },
            },
            data: goods.value.map((item: any) => ({
              value: item[this.statsEnergyUnit],
              item: {
                ...item,
                timeTitle: '查询时间',
              },
            })),
          }
        }).reverse(),
        ...cdata.filter(item => item.devName).map((goods: any, index: number) => {
          return {
            name: `${this.axisLabelDateFormatter(this.queryParams.cdate[0])}至${this.axisLabelDateFormatter(this.queryParams.cdate[1])}${StatsEnergyTabsMap.get(this.statsEnergyUnit)}-${goods.devName}`,
            tooltip: {
              trigger: 'axis',
            },
            type: 'line',
            smooth: true,
            // symbol: 'circle',
            // symbolSize: 8,
            showSymbol: false,
            itemStyle: {
              normal: {
                color: this.getLineColor(goods.devName).ccolor,
              },
            },
            data: goods.value.map((item: any) => ({
              value: item[this.statsEnergyUnit],
              item: {
                ...item,
                timeTitle: '对比时间',
              },
            })),
          }
        }).reverse(),
      ],
    }
  }
  private getLineColor(name: string) {
    let result = {
      color: '',
      ccolor: '',
    }
    switch (name) {
      case '空调':
        result.color = this.lineColors[1]
        result.ccolor = this.lineComparseColors[1]
        break
      case '灯光':
        result.color = this.lineColors[2]
        result.ccolor = this.lineComparseColors[2]
        break
      case '其他':
        result.color = this.lineColors[0]
        result.ccolor = this.lineComparseColors[0]
        break
    }
    return result
  }
}
